// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"7c4bae68","700":"9c63b8c2","711":"1d29b4c3","765":"d4cf90ff"}[chunkId] + ".chunk.css";
};